import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SharedModule } from "src/app/shared/shared.module";
import { ZoneManagementRouter } from "./zone-management.router";
import { ZoneSearchComponent } from "./zone/zone-search/zone-search.component";
import { NgModule } from "@angular/core";
import { ZoneCreateOrUpdateComponent } from "./zone/zone-create-or-update/zone-create-or-update.component";
import { PlatformCreateOrUpdateComponent } from "./platform/platform-create-or-update/platform-create-or-update.component";
import { EnvironmentCreateOrUpdateComponent } from "./environment/environment-create-or-update/environment-create-or-update.component";
import { ZoneAssetsComponent } from "./zone/zone-assets/zone-assets.component";
import { PlatformSearchComponent } from "./platform/platform-search/platform-search.component";
import { EnvironmentSearchComponent } from "./environment/environment-search/environment-search.component";
import { ZoneMapperDialogComponent } from "./zone/zone-mapper-dialog/zone-mapper-dialog.component";

@NgModule({
  declarations: [
    ZoneSearchComponent,
    ZoneCreateOrUpdateComponent,
    PlatformCreateOrUpdateComponent,
    EnvironmentCreateOrUpdateComponent,
    ZoneAssetsComponent,
    PlatformSearchComponent,
    EnvironmentSearchComponent,
    ZoneMapperDialogComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SharedModule,
    ZoneManagementRouter
  ]
})
export class ZoneManagementModule {}